import { markVersionSeen, hasUnseenRelease } from "@shared/changelogSeen";
import {
  fetchChangelog,
  getLatestRelease,
  getReleaseId,
} from "@shared/changelog";

type ReleaseNoticeSync = () => void;

const syncListeners = new Set<ReleaseNoticeSync>();

export function registerReleaseNoticeSync(sync: ReleaseNoticeSync): () => void {
  syncListeners.add(sync);
  return () => {
    syncListeners.delete(sync);
  };
}

function notifyReleaseNoticeSync(): void {
  for (const sync of syncListeners) {
    sync();
  }
}

export function markReleaseSeen(releaseId: string): void {
  markVersionSeen(releaseId);
  notifyReleaseNoticeSync();
}

export function isReleaseUnseen(releaseId: string): boolean {
  return hasUnseenRelease(releaseId);
}

export async function resolveLatestReleaseId(): Promise<string | null> {
  const data = await fetchChangelog();
  const latest = data ? getLatestRelease(data) : undefined;
  return latest ? getReleaseId(latest) : null;
}
